<template>
    <div v-loading="dataLoading">
        <el-form :model="formData" :rules="rules" ref="formData" label-position="top" size="medium">
            <div class="page-group-title"><span>基础设置</span></div>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="name" label="活动名称:">
                        <el-input v-model="formData.name" placeholder="请填写活动名称" :maxlength="40"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="datetimerange" label="活动有效期:">
                        <el-date-picker v-model="formData.datetimerange" type="datetimerange" start-placeholder="开始时间"
                            end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']" unlink-panels></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="onTime" label="上线时间:" :rules='[{ required: true, message: "请填写上线时间" }]'>
                        <el-date-picker type="datetime" v-model="formData.onTime"
                            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                        <small><span class="el-icon-warning"></span>上线前乐迷端活动列表不展示该活动.</small>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="offTime" label="下线时间:" :rules='[{ required: true, message: "请填写下线时间" }]'>
                        <el-date-picker type="datetime" v-model="formData.offTime"
                            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                        <small><span class="el-icon-warning"></span>下线后乐迷端活动列表不展示该活动.</small>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="poster" label="活动封面:">
                        <image-upload :url.sync="formData.poster" :urlFull.sync="formData.poster" :crop="true" :width="1005"
                            :height="540" ref="posterUpload" class="poster-upload" @onSuccess="handleImageSuccess1">
                        </image-upload>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="map" label="打卡地图:">
                        <image-upload :url.sync="formData.map" :urlFull.sync="formData.map" class="poster-upload"
                            @onSuccess="handleImageSuccess2">
                            <el-button type="primary" icon="el-icon-location" size="small"
                                class="addMarkerBtn" :disabled="formData.map ? false : true" @click="$refs.markerMap.show()">标记打卡点</el-button>
                        </image-upload>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="tickPic1" label="未打卡标记图标:">
                        <image-upload :url.sync="formData.tickPic1" :urlFull.sync="formData.tickPic1" class="poster-upload"
                            @onSuccess="handleImageSuccess3">
                        </image-upload>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="tickPic2" label="已打卡标记图标:">
                        <image-upload :url.sync="formData.tickPic2" :urlFull.sync="formData.tickPic2" class="poster-upload"
                            @onSuccess="handleImageSuccess4">
                        </image-upload>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="color" label="页面背景颜色:">
                        <el-color-picker v-model="formData.color" show-alpha></el-color-picker>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="activityId" label="绑定演出:">
                        <el-input v-model="formData.activityId" placeholder="演出ID" :maxlength="20"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="rule" label="活动规则:">
                        <tinymce v-model="formData.rule" :height="400" :toolbar="toolbar" :menubar="false" v-if="reFresh">
                        </tinymce>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="page-group-title"><span>奖励设置</span></div>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="rewardType" label="奖品类型:">
                        <el-select v-model="formData.rewardType">
                            <el-option :value="1" label="优惠券"></el-option>
                            <el-option :value="2" label="数藏"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="rewardId" label="奖品ID:">
                        <el-input v-model="formData.rewardId" placeholder="请输入奖品ID" :maxlength="20"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div class="page-btns-box MT20">
            <el-button @click="goBack">返 回</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确 定</el-button>
        </div>
        <Map ref="markerMap" :formData.sync="formData"></Map>
    </div>
</template>
<script>
import Tinymce from '@/components/Tinymce';
import ImageUpload from '@/components/ImageUpload';
import Map from './components/map.vue'

const defaultFormData = {
    name: "",
    datetimerange: null,
    startTime: null,
    endTime: null,
    rule: "",
    poster: "",
    configList: [],
    map: "",
    rewardId: "",
    rewardType: 2,
    onTime: "",
    offTime: "",
    color: "",
    tickPic1: "",
    tickPic2: "",
    activityId: ""
}

export default {
    props: {
        id: {
            type: [Number, String],
            default: ""
        }
    },
    components: {
        Map, Tinymce, ImageUpload
    },
    data() {
        return {
            formData: {
                ...defaultFormData
            },
            dataLoading: false,
            btnLoading: false,
            rules: {
                name: [{ required: true, message: "请填写活动名称" }],
                datetimerange: [{ required: true, message: "请填写活动有效期" }],
                poster: [{ required: true, message: "请上传活动封面" }],
                map: [{ required: true, message: "请上传打卡地图" }],
                rewardId: [{ required: true, message: "请输入奖品ID" }],
                tickPic1: [{ required: true, message: "请上传未打卡标记图标" }],
                tickPic2: [{ required: true, message: "请上传已打卡标记图标" }],
                activityId: [{ required: true, message: "请输入演出ID" }],
            },
            toolbar: ['formatselect fontsizeselect | forecolor bold strikethrough | alignleft aligncenter alignright alignjustify | image media'],
            reFresh: false,
            redirect: this.$route.query.redirect || '/promotion/checkIn/list',
        }
    },
    mounted() {
        if (this.id) {
            this.getDetailData();
        } else {
            // this.formData = {
            //     ...defaultFormData,
            // }
            this.reFresh = true;
        }
    },
    methods: {
        getDetailData() {
            this.dataLoading = true;
            this.$request({
                url: "/scene/punch/detail",
                method: "POST",
                params: {
                    id: this.id
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.formData = {
                            ...defaultFormData,
                            ...result,
                            datetimerange: result.startTime ? [result.startTime, result.endTime] : [],
                        };
                        // this.formData.stageList.map((v, i) => v.stage = i)
                        this.reFresh = true;
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //图片上传成功后执行 需要重置海报的水印图
        handleImageSuccess1() {
            if (this.formData.poster) {
                this.$refs["formData"].clearValidate('poster');
            }
        },
        handleImageSuccess2() {
            if (this.formData.map) {
                this.formData.configList = [];
                this.$refs["formData"].clearValidate('map');
            }
        },
        handleImageSuccess3() {
            if (this.formData.tickPic1) {
                this.$refs["formData"].clearValidate('tickPic1');
            }
        },
        handleImageSuccess4() {
            if (this.formData.tickPic2) {
                this.$refs["formData"].clearValidate('tickPic2');
            }
        },
        //表单提交
        submitForm() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    if (this.formData.configList.length < 1) {
                        this.$message.error('请为地图标记打卡点');
                        return;
                    }
                    if (this.$utils.compareDate(this.formData.onTime, this.formData.offTime)) {
                        this.$message.error('下线时间必须大于上线时间');
                        return;
                    }
                    this.btnLoading = true;

                    this.$request({
                        url: '/scene/punch/saveOrUpdate',
                        data: {
                            ...this.formData,
                            startTime: this.formData.datetimerange[0],
                            endTime: this.formData.datetimerange[1],
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.goBack();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        },
        //返回
        goBack() {
            if (this.redirect) {
                this.$router.push({
                    path: this.redirect,
                });
            } else {
                this.$router.go(-1);
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.addMarkerBtn {
    margin-left: 10px;
}</style>